import React from 'react';
import Footer from '../components/Footer';
import GamePage from '../components/GamePage';

import BalloonsOdyssey_Advertisement_Img1 from '../images/balloonsodyssey/images-17.png';
import BalloonsOdyssey_Advertisement_Img2 from '../images/balloonsodyssey/images-18.png';

export default function BalloonsOdyssey_Advertisement() {
  return (
    <>
      <GamePage
        name="Balloons Odyssey: advertisement panels"
        description="Advertisement panel fully designed in Adobe Illustrator."
        images={[BalloonsOdyssey_Advertisement_Img1, BalloonsOdyssey_Advertisement_Img2]}
        conclusion="Already implemented in the game Balloons Odyssey."
      />
      <Footer />
    </>
  );
}